import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.1 } }),
};

// Bento spans give the grid an editorial, asymmetric rhythm
const spans = [
  "md:col-span-7 md:row-span-2",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-12",
];

export const Categories = ({ categories, activeCategory, onSelect }) => (
  <section id="categorie" className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
    <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <div>
        <p className="mb-4 text-xs uppercase tracking-overline text-electric">Sette mondi</p>
        <h2 className="max-w-xl font-serif text-4xl font-light leading-tight text-ink md:text-6xl">
          Ogni categoria, un capitolo del tuo mese
        </h2>
      </div>
      <button
        onClick={() => onSelect("all")}
        data-testid="category-all-button"
        className={`self-start rounded-full border px-6 py-3 text-sm font-medium transition-colors ${
          activeCategory === "all" ? "border-electric bg-electric text-cream" : "border-ink/20 text-ink hover:bg-ink hover:text-cream"
        }`}
      >
        Tutti i prodotti
      </button>
    </div>

    <div className="grid auto-rows-[220px] grid-cols-1 gap-5 md:grid-cols-12 md:auto-rows-[260px]">
      {categories.map((cat, i) => (
        <motion.button
          key={cat.slug}
          variants={reveal}
          custom={i}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          onClick={() => onSelect(cat.slug)}
          data-testid={`category-card-${cat.slug}`}
          className={`clip-frame group relative rounded-3xl text-left ${spans[i] || "md:col-span-4"} ${
            activeCategory === cat.slug ? "ring-2 ring-electric ring-offset-2 ring-offset-cream" : ""
          }`}
        >
          <img src={cat.image} alt={cat.label} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-8">
            <span className="text-xs uppercase tracking-overline text-white/80">{cat.tagline}</span>
            <div>
              <h3 className="font-serif text-3xl font-light text-white md:text-4xl">{cat.label}</h3>
              <p className="mt-1 max-w-xs text-sm text-white/80 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                {cat.description}
              </p>
            </div>
          </div>
        </motion.button>
      ))}
    </div>
  </section>
);
